module.exports = __webpack_public_path__ + "img/x-circle.c92845c7.svg";